<mat-toolbar color="primary" class="mat-bg-primary-800 not-found-toolbar">
    <img src="assets/eacat_logo.svg" alt="EACAT">
    <span *ngIf="showPreprodIndicator" class="preprod-indicator">PREPRODUCCIÓ</span>
    <span class="icons-spacer"></span>
    <div *ngIf="configService.config.connectedEntityDetail != null" class="d-flex align-items-center login-widget">
        <div class="circle d-flex justify-content-center align-items-center"
            [class]="'color' + configService.config.connectedEntityDetail.entity.entityInfo.getNameInitialColorIndex()">
            <div>{{configService.config.connectedEntityDetail.entity.entityInfo.name.charAt(0).toUpperCase()}}</div>
        </div>
        <div class="d-flex flex-column login-text">
            <div class="overline" data-test="notFoundEntity_Test">
                {{configService.config.connectedEntityDetail.entity.entityInfo.name}}
            </div>
            <div class="mat-caption" data-test="notFoundUser_Test">{{configService.config.connectedUser.name}}</div>
        </div>
    </div>
</mat-toolbar>

<div class="not-found-body d-flex flex-column align-items-center">
    <div class="not-found-code">404</div>
    <h1 class="not-found-title">No hem trobat la pàgina que busques</h1>
    <p class="not-found-text">És possible que l'enllaç estigui mal escrit o que la pàgina ja no estigui disponible.</p>
    <button mat-flat-button color="primary" routerLink="/" data-test="notFoundHome_Test">Tornar a l'inici</button>
</div>
